import { render } from "./BookList.vue?vue&type=template&id=3bf7bcce"
import script from "./BookList.vue?vue&type=script&lang=js"
export * from "./BookList.vue?vue&type=script&lang=js"
script.render = render

export default script